<script lang="ts">
import { defineComponent, h } from 'vue';

import { useRender } from '@components/composable';

import { makeSlideViewItemProps } from '../CdsSlideView/props';
import { CdsSlideViewItem } from '../CdsSlideView';

export const componentName = 'CdsTabsViewItem';

export default defineComponent({
  name: componentName,
  props: {
    ...makeSlideViewItemProps()
  },
  setup(props, { slots }) {
    useRender(() => {
      return h(
        CdsSlideViewItem,
        {
          ...props,
          class: 'cds-tabs-view-item'
        },
        slots
      );
    });

    return {};
  }
});
</script>
